import useIsDesktopLayout from '@/hooks/layout/useIsDesktopLayout';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import appContent from '@/services/content/appContent.typed';

import SkipDeliveryDesktop from './SkipDeliveryDesktop';
import SkipDeliveryMobile from './SkipDeliveryMobile';

const SkipDelivery = () => {
    const isDesktopLayout = useIsDesktopLayout();
    const skipDeliveryContent = appContent.getAutoDeliveryContent()?.skipDeliveryContent;
    const title = skipDeliveryContent?.title || '';

    useDocumentTitle(title);

    return isDesktopLayout ? <SkipDeliveryDesktop /> : <SkipDeliveryMobile title={title} />;
};

export default SkipDelivery;
